import { 
  faTag, faHome, faShoppingCart, faUtensils, faCar, faPlane,
  faFilm, faGamepad, faTshirt, faHeartbeat, faGraduationCap,
  faBus, faWifi, faCoffee, faGift, faPaw, faGlassCheers, faCheck,
  faLightbulb, faMedkit, faEllipsisH, faCut, faMoneyBillWave
} from '@fortawesome/free-solid-svg-icons';

// Map of icon names to FontAwesome icon objects
export const iconMap = {
  'tag': faTag,
  'home': faHome,
  'shopping-cart': faShoppingCart,
  'utensils': faUtensils,
  'car': faCar,
  'plane': faPlane,
  'film': faFilm,
  'gamepad': faGamepad,
  'tshirt': faTshirt,
  'heartbeat': faHeartbeat,
  'graduation-cap': faGraduationCap,
  'bus': faBus,
  'wifi': faWifi,
  'coffee': faCoffee,
  'gift': faGift,
  'paw': faPaw,
  'glass-cheers': faGlassCheers,
  'check': faCheck,
  'lightbulb': faLightbulb,
  'medkit': faMedkit,
  'ellipsis-h': faEllipsisH,
  'cut': faCut,
  'money-bill-wave': faMoneyBillWave
};

/**
 * Get a FontAwesome icon object from an icon name string
 * @param {string} iconName - The name of the icon (e.g., 'shopping-cart')
 * @param {object} defaultIcon - The default icon to return if iconName is not found in the map
 * @returns {object} - FontAwesome icon object
 */
export const getIconFromString = (iconName, defaultIcon = faTag) => {
  if (!iconName) return defaultIcon;
  return iconMap[iconName] || defaultIcon;
};

/**
 * List of all available icon options for selection in UI
 */
export const iconOptions = Object.keys(iconMap).map(name => ({
  name,
  icon: iconMap[name]
}));
